/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc
 */
import * as References from './ApplicationGovernanceAppAuthRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#getApplicationGovernance
 */
export const GET_APPLICATION_GOVERNANCE_QUERY_FIELD_NAME = 'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_getApplicationGovernance';
export const GET_APPLICATION_GOVERNANCE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_APPLICATION_GOVERNANCE_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getApplicationGovernanceRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#enableApplicationInstallable
 */
export const ENABLE_APPLICATION_INSTALLABLE_MUTATION_FIELD_NAME = 'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_enableApplicationInstallable';
export const ENABLE_APPLICATION_INSTALLABLE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: ENABLE_APPLICATION_INSTALLABLE_MUTATION_FIELD_NAME,
  args: ['appId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.enableApplicationInstallableRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#getApprovedApplicationPaginated
 */
export const GET_APPROVED_APPLICATION_PAGINATED_QUERY_FIELD_NAME = 'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_getApprovedApplicationPaginated';
export const GET_APPROVED_APPLICATION_PAGINATED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_APPROVED_APPLICATION_PAGINATED_QUERY_FIELD_NAME,
  args: ['offset', 'pageLength'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getApprovedApplicationPaginatedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#revokeApproval
 */
export const REVOKE_APPROVAL_MUTATION_FIELD_NAME = 'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_revokeApproval';
export const REVOKE_APPROVAL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REVOKE_APPROVAL_MUTATION_FIELD_NAME,
  args: ['appId'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.revokeApprovalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#getAppGovernancePermissions
 */
export const GET_APP_GOVERNANCE_PERMISSIONS_QUERY_FIELD_NAME = 'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_getAppGovernancePermissions';
export const GET_APP_GOVERNANCE_PERMISSIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_APP_GOVERNANCE_PERMISSIONS_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getAppGovernancePermissionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#approveAppGovernancePermissions
 */
export const APPROVE_APP_GOVERNANCE_PERMISSIONS_MUTATION_FIELD_NAME = 'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_approveAppGovernancePermissions';
export const APPROVE_APP_GOVERNANCE_PERMISSIONS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: APPROVE_APP_GOVERNANCE_PERMISSIONS_MUTATION_FIELD_NAME,
  args: ['appId', 'installPermissionAccessState', 'optionalAppPermissions', 'conditionallyRequiredAppPermissions', 'entityTypeAndIds'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.approveAppGovernancePermissionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#updateAllowedAppPermissions
 */
export const UPDATE_ALLOWED_APP_PERMISSIONS_MUTATION_FIELD_NAME = 'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_updateAllowedAppPermissions';
export const UPDATE_ALLOWED_APP_PERMISSIONS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_ALLOWED_APP_PERMISSIONS_MUTATION_FIELD_NAME,
  args: ['appId', 'conditionallyRequiredAppPermissions', 'optionalAppPermissions'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.updateAllowedAppPermissionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#updateAllowedEntityTypeAndIds
 */
export const UPDATE_ALLOWED_ENTITY_TYPE_AND_IDS_MUTATION_FIELD_NAME = 'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_updateAllowedEntityTypeAndIds';
export const UPDATE_ALLOWED_ENTITY_TYPE_AND_IDS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_ALLOWED_ENTITY_TYPE_AND_IDS_MUTATION_FIELD_NAME,
  args: ['appId', 'installPermissionAccessState', 'entityTypeAndIds'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.updateAllowedEntityTypeAndIdsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#getApprovableAppsWithStatus
 */
export const GET_APPROVABLE_APPS_WITH_STATUS_QUERY_FIELD_NAME = 'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_getApprovableAppsWithStatus';
export const GET_APPROVABLE_APPS_WITH_STATUS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_APPROVABLE_APPS_WITH_STATUS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.getApprovableAppsWithStatusRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#removeAppPermissionsFromInstalls
 */
export const REMOVE_APP_PERMISSIONS_FROM_INSTALLS_MUTATION_FIELD_NAME = 'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_removeAppPermissionsFromInstalls';
export const REMOVE_APP_PERMISSIONS_FROM_INSTALLS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REMOVE_APP_PERMISSIONS_FROM_INSTALLS_MUTATION_FIELD_NAME,
  args: ['appId', 'appPermissionIds'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.removeAppPermissionsFromInstallsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#getOrCreateConnectedAppObject
 */
export const GET_OR_CREATE_CONNECTED_APP_OBJECT_MUTATION_FIELD_NAME = 'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_getOrCreateConnectedAppObject';
export const GET_OR_CREATE_CONNECTED_APP_OBJECT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: GET_OR_CREATE_CONNECTED_APP_OBJECT_MUTATION_FIELD_NAME,
  args: ['appId'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.getOrCreateConnectedAppObjectRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#getAppsGovernanceStatus
 */
export const GET_APPS_GOVERNANCE_STATUS_QUERY_FIELD_NAME = 'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_getAppsGovernanceStatus';
export const GET_APPS_GOVERNANCE_STATUS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_APPS_GOVERNANCE_STATUS_QUERY_FIELD_NAME,
  args: ['appIds'],
  fetcher(request, ctx) {
    var _ctx$customClient12;
    return ((_ctx$customClient12 = ctx.customClient) !== null && _ctx$customClient12 !== void 0 ? _ctx$customClient12 : chirpClient).call(References.getAppsGovernanceStatusRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#getApprovedApplicationsForUserPaged
 */
export const GET_APPROVED_APPLICATIONS_FOR_USER_PAGED_QUERY_FIELD_NAME = 'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_getApprovedApplicationsForUserPaged';
export const GET_APPROVED_APPLICATIONS_FOR_USER_PAGED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_APPROVED_APPLICATIONS_FOR_USER_PAGED_QUERY_FIELD_NAME,
  args: ['offset', 'pageLength'],
  fetcher(request, ctx) {
    var _ctx$customClient13;
    return ((_ctx$customClient13 = ctx.customClient) !== null && _ctx$customClient13 !== void 0 ? _ctx$customClient13 : chirpClient).call(References.getApprovedApplicationsForUserPagedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#getListingIdsToExclude
 */
export const GET_LISTING_IDS_TO_EXCLUDE_QUERY_FIELD_NAME = 'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_getListingIdsToExclude';
export const GET_LISTING_IDS_TO_EXCLUDE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_LISTING_IDS_TO_EXCLUDE_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient14;
    return ((_ctx$customClient14 = ctx.customClient) !== null && _ctx$customClient14 !== void 0 ? _ctx$customClient14 : chirpClient).call(References.getListingIdsToExcludeRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#getAppDataPermissionsStatus
 */
export const GET_APP_DATA_PERMISSIONS_STATUS_QUERY_FIELD_NAME = 'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_getAppDataPermissionsStatus';
export const GET_APP_DATA_PERMISSIONS_STATUS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_APP_DATA_PERMISSIONS_STATUS_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(request, ctx) {
    var _ctx$customClient15;
    return ((_ctx$customClient15 = ctx.customClient) !== null && _ctx$customClient15 !== void 0 ? _ctx$customClient15 : chirpClient).call(References.getAppDataPermissionsStatusRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.applications.governance.rpc.ApplicationGovernanceAppAuthRpc#checkAppInstallability
 */
export const CHECK_APP_INSTALLABILITY_QUERY_FIELD_NAME = 'com_hubspot_applications_governance_rpc_ApplicationGovernanceAppAuthRpc_checkAppInstallability';
export const CHECK_APP_INSTALLABILITY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: CHECK_APP_INSTALLABILITY_QUERY_FIELD_NAME,
  args: ['appId', 'conditionallyRequiredAppPermissionIds', 'optionalAppPermissionIds'],
  fetcher(request, ctx) {
    var _ctx$customClient16;
    return ((_ctx$customClient16 = ctx.customClient) !== null && _ctx$customClient16 !== void 0 ? _ctx$customClient16 : chirpClient).call(References.checkAppInstallabilityRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});